import { Tab, TabList, Tabs } from "@chakra-ui/react";
import React, { useState } from "react";

import PriceRule from "./PriceRule";
import PriceRubleByTerm from "./PriceRuleByTerm";
const RulesPage = () => {
  const [estadoFiltro, setEstadoFiltro] = useState(0);

  const handleTabChange = (index) => {
    setEstadoFiltro(index);
  };

  return (
    <div>
      <section className="container prices-table-filter no-bottom">
        <Tabs variant="enclosed" isFitted index={estadoFiltro} onChange={handleTabChange}>
          <TabList className="filter-tabs no-bottom">
            <Tab className="text-[#9DA2B6] font-bold text-xl flex-grow flex-shrink text-center py-2 px-8  menu">
              Preço Regra
            </Tab>
            <Tab className="text-[#9DA2B6] font-bold text-xl flex-grow flex-shrink text-center py-2 px-8  menu">
              Prazo Regra
            </Tab>
          </TabList>
        </Tabs>
      </section>

      <div className="tab-content">
        {estadoFiltro === 0 && <PriceRule />}
        {estadoFiltro === 1 && <PriceRubleByTerm />}
      </div>
    </div>
  );
};

export default RulesPage;
